export const mergeMedicalOrganizationVaccines = ({
  medicalOrganizations,
  organizationVaccines,
}) => {
  return medicalOrganizations.map((org) => {
    const vaccines = organizationVaccines
      .filter((v) => v.medicalOrganizationId === org.id);

    return {
      ...org,
      vaccines: vaccines.length === 0 ? [] : vaccines[0].vaccines,
      vaccineId: vaccines.length === 0 ? null : vaccines[0].id,
      vaccineCreatedAt: vaccines.length === 0 ? null : vaccines[0].createdAt,
    };
  });
};
